import * as React from 'react';
import {Component} from 'react';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';
import {SidebarContent} from "../shared/sidebar";

import * as meLogo from "../images/me-242.jpg"; // Tell Webpack this JS file uses this image
import * as frontImage from "../images/home-banner.jpg"; // Tell Webpack this JS file uses this image
import * as FaHome from 'react-icons/lib/fa/home';
import * as FaInfo from 'react-icons/lib/fa/info';

// import '../css/blog-post.css'; // make it pretty!

interface TemplateProps {
    data: {
        markdownRemark: {
            frontmatter: {
                title: string;
            },
            html: string
        };
    };
}

class BlogPostTemplate extends Component<TemplateProps, void> {
    render() {
        // this.props.data // this prop will be injected by the GraphQL query we'll write in a bit
      const post = this.props.data.markdownRemark; // data.markdownRemark holds our post data
      return (
          <div className="page blog-post">
              <Helmet title={`Jaanek Oja - ${post.frontmatter.title}`} />
              <header>
                  <div className="home-icon">
                      <a href="/" className="link"><FaHome/></a>
                  </div>
                  <div className="top-links">
                      {/*<a href="/resume" className="link"><FaBook/><span className="link-text">R&eacute;sum&eacute;</span></a>*/}
                      <a href="/info" className="link"><FaInfo/><span className="link-text">Info</span></a>
                  </div>
                  <div className="image-area" style={{backgroundImage: "url(" + frontImage + ")"}}>
                      <div className="me-logo">
                          <a href="/"><img className="img-cicle" src={meLogo} alt="Me & Myself"/></a>
                      </div>
                  </div>
              </header>
              <main className="content">
                  <article className="left post">
                      <div className="blog-post-content">
                          <h1>{post.frontmatter.title}</h1>
                          <div className="post-date"><span>{post.frontmatter.date}</span></div>
                          <div className="content" dangerouslySetInnerHTML={{ __html: post.html }} />
                      </div>
                  </article>
                  <SidebarContent/>
              </main>
          </div>
      )
    }
}
export default BlogPostTemplate;

// Fullstack Tutorial for GraphQL - https://www.howtographql.com/
export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        path
        title
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/templates/blog-post.tsx